<template>
  <div>
    <div class="content d-flex flex-column mt-2" v-if="fields">
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.tipo_pesquisaId"
            :valid.sync="fieldsComputed.tipo_pesquisaId.valid"
            :label="fieldsComputed.tipo_pesquisaId"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>        
      </div>
      <div class="row mt-n2">        
        <div class="col-2">
             <input-v
                v-model="projeto.tipo_trl"
                :valid.sync="fieldsComputed.tipo_trl.valid"
                :label="fieldsComputed.tipo_trl"
                :editable="canEdit"
                :opts="{ ...opts, tipoTrl: trlTypes }"
             >
             </input-v>
        </div>                
        <div class="col">
          <input-v
            v-model="projeto.nivel_trl_inicial"
            :valid.sync="fieldsComputed.nivel_trl_inicial.valid"
            :label="fieldsComputed.nivel_trl_inicial"
            :editable="canEdit"
            :opts="{ ...opts, nivelTrl: nivelTrlOptions }"
          >
          </input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.nivel_trl_final"
            :valid.sync="fieldsComputed.nivel_trl_final.valid"
            :label="fieldsComputed.nivel_trl_final"
            :editable="canEdit"
            :opts="{ ...opts, nivelTrl: nivelTrlOptions }"
          >
          </input-v>
        </div>
      </div>
      <div class="row mt-n2">  
        <div class="col-12">
          <g-file-picker
            :value="anexoJustificativaTrl"
            @update:value="$emit('update:anexoJustificativaTrl', $event)"
            label="Anexo Justificativa TRL"
            multiple
            :disabled="!canEdit"
            :label-bold="true"
            :show-download="true"
            :max-file-size="10485760"
          />
        </div>     
        <div class="col">
          <input-v
            v-model="projeto.justificativa_trl"
            :valid.sync="fieldsComputed.justificativa_trl.valid"
            :label="fieldsComputed.justificativa_trl"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>                
      </div>
      <div class="row mt-n2">
      </div>
      <div class="row">
        <div class="col">
          <input-v
            v-model="projeto.area_projeto"
            :valid.sync="fieldsComputed.area_projeto.valid"
            :label="fieldsComputed.area_projeto"            
            :editable="canEdit"
            :opts="opts"
          >
          </input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.naturezaId"
            :valid.sync="fieldsComputed.naturezaId.valid"
            :label="fieldsComputed.naturezaId"
            :editable="canEdit"
            :opts="opts"
          ></input-v>
        </div>     
      </div>
      <div class="row mt-n2">
        <div class="col">
          <input-v
            v-model="projeto.keyword_1"
            :valid.sync="fieldsComputed.keyword_1.valid"
            :label="fieldsComputed.keyword_1"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.keyword_2"
            :valid.sync="fieldsComputed.keyword_2.valid"
            :label="fieldsComputed.keyword_2"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.keyword_3"
            :valid.sync="fieldsComputed.keyword_3.valid"
            :label="fieldsComputed.keyword_3"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.keyword_4"
            :valid.sync="fieldsComputed.keyword_4.valid"
            :label="fieldsComputed.keyword_4"
            :editable="canEdit"
          ></input-v>
        </div>
        <div class="col">
          <input-v
            v-model="projeto.keyword_5"
            :valid.sync="fieldsComputed.keyword_5.valid"
            :label="fieldsComputed.keyword_5"
            :editable="canEdit"
          ></input-v>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import fields from '../LBEnquadrados.fields';
import { isStrictProject } from "@/helpers/projectValidators";

export default {
  props: {
    projeto: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true,
      default: false
    },
    canEditStatus: {
      type: Boolean,
      required: true,
      default: false
    },
    isClient: {
      type: Boolean,
      required: true,
      default: false
    },
    cliente: {
      type: Object,
      required: true
    },
    hasAccessPlurianual: {
      type: Boolean,
      required: true,
      default: false
    },
    opts: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    },
    anexoJustificativaTrl: {
      type: Array,
      default: () => []
    },
  },
  components: {
    'input-v': () => import('@/components/input-v.vue'),
    "g-file-picker": () => import("@/components/g-file-picker.vue"),
  },
  data() { 
    return {
      fields,
    }
  },
  computed: {
    fieldsComputed: function() {
      const fields = cloneDeep(this.fields.classificacao);
      const isStrict = isStrictProject(this.projeto);

      return fields.reduce(
        (acc, field) => {
          if (!isStrict) {
             field.rules = (field.rules || []).filter(r => r.rule !== 'required');
          }
          return { ...acc, [field.key]: field }
        },
        {}
      );
    },
    trlTypes: function() {
      return [
        { id: 1, descricao: 'Produtos' },
        { id: 2, descricao: 'Processos' },
        { id: 3, descricao: 'Software' },
        { id: 4, descricao: 'Fármacos/Biofármacos' },
      ];
    },
    nivelTrlOptions: function() {
      const tipoTrl = this.projeto.tipo_trl;
      
      if (!tipoTrl) {
        return this.opts.nivelTrl;
      }

      const descriptions = {
        1: { // Produtos
            1: "TRL 1 / MRL 1 / STRL 1 / TRL 1",
            2: "TRL 2 / MRL 2 / STRL 2 / TRL 2",
            3: "TRL 3 / MRL 3 / STRL 3 / TRL 3",
            4: "TRL 4 / MRL 4 / STRL 4 / TRL 4",
            5: "TRL 5 / MRL 5 / STRL 5 / TRL 5",
            6: "TRL 6 / MRL 6 / STRL 6 / TRL 6",
            7: "TRL 7 / MRL 7 / STRL 7 / TRL 7",
            8: "TRL 8 / MRL 8 / STRL 8 / TRL 8",
            9: "TRL 9 / MRL 9 / STRL 9 / TRL 9"
        },
        2: { // Processos
            1: "TRL 1 / MRL 1 / STRL 1 / TRL 1",
            2: "TRL 2 / MRL 2 / STRL 2 / TRL 2",
            3: "TRL 3 / MRL 3 / STRL 3 / TRL 3",
            4: "TRL 4 / MRL 4 / STRL 4 / TRL 4",
            5: "TRL 5 / MRL 5 / STRL 5 / TRL 5",
            6: "TRL 6 / MRL 6 / STRL 6 / TRL 6",
            7: "TRL 7 / MRL 7 / STRL 7 / TRL 7",
            8: "TRL 8 / MRL 8 / STRL 8 / TRL 8",
            9: "TRL 9 / MRL 9 / STRL 9 / TRL 9"
        },
        3: { // Software
            1: "TRL 1 / MRL 1 / STRL 1 / TRL 1",
            2: "TRL 2 / MRL 2 / STRL 2 / TRL 2",
            3: "TRL 3 / MRL 3 / STRL 3 / TRL 3",
            4: "TRL 4 / MRL 4 / STRL 4 / TRL 4",
            5: "TRL 5 / MRL 5 / STRL 5 / TRL 5",
            6: "TRL 6 / MRL 6 / STRL 6 / TRL 6",
            7: "TRL 7 / MRL 7 / STRL 7 / TRL 7",
            8: "TRL 8 / MRL 8 / STRL 8 / TRL 8",
            9: "TRL 9 / MRL 9 / STRL 9 / TRL 9"
        },
        4: { // Fármacos
           1: "TRL 1 / MRL 1 / STRL 1 / TRL 1",
           2: "TRL 2 / MRL 2 / STRL 2 / TRL 2",
           3: "TRL 3 / MRL 3 / STRL 3 / TRL 3",
           4: "TRL 4 / MRL 4 / STRL 4 / TRL 4",
           5: "TRL 5 / MRL 5 / STRL 5 / TRL 5",
           6: "TRL 6 / MRL 6 / STRL 6 / TRL 6",
           7: "TRL 7 / MRL 7 / STRL 7 / TRL 7",
           8: "TRL 8 / MRL 8 / STRL 8 / TRL 8",
           9: "TRL 9 / MRL 9 / STRL 9 / TRL 9"
        }
      };

      const currentTypeMap = descriptions[tipoTrl];
      if (!currentTypeMap) return this.opts.nivelTrl;

      return this.opts.nivelTrl.map(opt => ({
          ...opt,
          descricao: currentTypeMap[opt.id] || opt.descricao
      }));
    }
  },
  methods: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
}
</script>

<style scoped>
</style>
